<template>
  <div>
    <small-slims-loader v-if="dataSource === null || franchiseFilter.length === 0 || fmmFilter.length === 0 || fadFilter.length === 0" class="uk-padding-small uk-position-top-right"></small-slims-loader>
    <div v-if="dataSource !== null && franchiseFilter.length !== 0  && fmmFilter.length !== 0 && fadFilter.length !== 0">
      <DxDataGrid
          :data-source="dataSource"
          :show-borders="true"
          height="700px"
          @row-prepared="onRowPrepared"
          @exporting="onExporting"
          @toolbar-preparing="onToolbarPreparing($event)">

        <DxScrolling
            mode="infinite"/>

        <DxExport
            :enabled="true"
        />

        <DxColumn
            class="uk-text-center"
            data-field="groupBy"
            :caption="groupByCaption"/>

        <DxColumn
            class="uk-text-center"
            data-field="lunch"
            cell-template="template"/>

        <DxColumn
            class="uk-text-center"
            data-field="midday"
            cell-template="template"/>

        <DxColumn
            data-field="dinner"
            cell-template="template"/>

        <DxColumn
            data-field="lateNight"
            cell-template="template"/>

        <DxColumn
            data-field="total"
            class="total-column"
            cell-template="templateTotal"/>

        <template #template="{ data }">
          <div :class="{'total-column': isTotalRow(data), 'above-zero': data.value > 0, 'below-zero': data.value < 0}">
            <div class="uk-padding-small uk-padding-remove-vertial uk-align-center uk-text-center font-size">
              {{ data.value | formatPercentage }}
            </div>
          </div>
        </template>

        <template #templateTotal="{ data }">
          <div :class="{'total-column': true, 'above-zero': data.value > 0, 'below-zero': data.value < 0}">
            <div class="uk-padding-small uk-align-center uk-text-center font-size">{{
                data.value | formatPercentage
              }}
            </div>
          </div>
        </template>

      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid, DxColumn, DxPaging, DxPager, DxScrolling, DxExport
} from 'devextreme-vue/data-grid';
import {createStore} from "devextreme-aspnet-data-nojquery";
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import axios from "axios";
import SmallSlimsLoader from "@/Components/Homepage/Components/SmallSlimsLoader.vue";
export default {
  name: "CompCalculatorGrid",
  components: {
    DxDataGrid, DxColumn, DxPaging, DxPager, DxScrolling, DxExport, SmallSlimsLoader
  },

  data() {
    return {
      currentGroupBy: "Channel",
      groupByCaption: "Channel",
      currentFmm: "All",
      currentMetric: "NetSales",
      currentFranchiseGroup: "All",
      currentFad: "All",
      isLoading: false,
      franchiseFilter: [],
      fmmFilter: [],
      fadFilter: [],
      dataSource: null,

      metrics: [
        {
          text: "Metric Value: Sales",
          value: "NetSales"
        },

        {
          text: "Metric Value: Traffic",
          value: "GuestCount"
        },
      ],


      items: [
        {
          text: "Group By: Channel",
          value: "main.Channel"
        },

        {
          text: "Group By: Store Name",
          value: "main.StoreName"
        },

        {
          text: "Group By: Group Name",
          value: "main.GroupName"
        },

        {
          text: "Group By: Corporate Or Franchise",
          value: "main.CorporateOrFranchise"
        },

        {
          text: "Group By: State",
          value: "loc.State"
        },

        {
          text: "Group By: City",
          value: "loc.City"
        },

        {
          text: "Group By: FAD",
          value: "case when FAD is null then 'Unattributed' else FAD end"
        },
        {
          text: "Group By: FMM",
          value: "case when FMM is null then 'Unattributed' else FMM end"
        },
      ],

      timeItems: [
        {
          text: "Time Period: Yesterday",
          value: "Yesterday"
        },

        {
          text: "Time Period: Rolling 7",
          value: "Rolling 7"
        },

        {
          text: "Time Period: Period",
          value: "Period"
        },

        {
          text: "Time Period: YTD",
          value: "YTD"
        },
      ]
    }
  },

  props: {
    groupBy: String,
    timeRange: String,
  },

  filters: {
    formatPercentage(number) {
      if (number === undefined)
        return 'Null';

      number = number.toString() + "%";

      return number;
    },
  },

  methods: {

    metricChanged(e) {
      this.currentMetric = e.value;
      const url = this.getApiUrl();

      this.dataSource = createStore({
        loadUrl: `${url}/api/slims-report/comp-sales/comp-calculator`,
        onBeforeSend: (method, ajaxOptions) => {
          const token = this.getTokenSilently();
          const clientId = this.getClientId();
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          }
          ajaxOptions.data = {
            groupBy: this.currentGroupBy,
            timeRange: this.timeRange,
            metric: this.currentMetric,
            franchise: this.currentFranchiseGroup,
            fmm: this.currentFmm,
            fad: this.currentFad,
            clientId: clientId
          }
        }
      });
    },

    groupChanged(e) {
      this.currentGroupBy = e.value;
      let obj = this.items.find(o => o.value === e.value);
      this.groupByCaption = obj.text.substring(obj.text.indexOf(":") + 1);
      const url = this.getApiUrl();


      this.dataSource = createStore({
        loadUrl: `${url}/api/slims-report/comp-sales/comp-calculator`,
        onBeforeSend: (method, ajaxOptions) => {
          const token = this.getTokenSilently();
          const clientId = this.getClientId();
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          }
          ajaxOptions.data = {
            groupBy: this.currentGroupBy,
            timeRange: this.timeRange,
            metric: this.currentMetric,
            franchise: this.currentFranchiseGroup,
            fmm: this.currentFmm,
            fad: this.currentFad,
            clientId: clientId
          }
        }
      });
    },

    onExporting(e) {
      let groupBy = this.currentGroupBy;
      let timeRange = this.timeRange

      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Contribution To Comp');
      exportDataGrid({
        component: e.component,
        worksheet: worksheet
      }).then(function (dataGridRange) {
        for (let x = 2; x < dataGridRange.to.column + 1; x++) {
          for (let y = 2; y < dataGridRange.to.row + 1; y++) {

            let cell = worksheet.getRow(y).getCell(x)

            let cell2 = cell.value

            let cellValue = Number(cell2).toFixed(1);

            Object.assign(
                worksheet.getRow(y).getCell(x),
                {value: cellValue + "%"}
            );
          }
        }
      }).then(function () {
        workbook.xlsx.writeBuffer().then(function (buffer) {
          saveAs(new Blob([buffer], {type: "application/octet-stream"}),
              groupBy + ' Comp Calculator' + ' (' + timeRange + ')' + '.xlsx');
        });

      });
    },

    franchiseChanged(e) {
      this.currentFranchiseGroup = e.value
      const url = this.getApiUrl();

      this.dataSource = createStore({
        loadUrl: `${url}/api/slims-report/comp-sales/comp-calculator`,
        onBeforeSend: (method, ajaxOptions) => {
          const token = this.getTokenSilently();
          const clientId = this.getClientId();
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          }
          ajaxOptions.data = {
            groupBy: this.currentGroupBy,
            timeRange: this.timeRange,
            metric: this.currentMetric,
            franchise: this.currentFranchiseGroup,
            fmm: this.currentFmm,
            fad: this.currentFad,
            clientId: clientId
          }
        }
      });
    },

    fmmChanged(e)
    {
      this.currentFmm = e.value;
      const url = this.getApiUrl();
      const clientId = this.getClientId();

      this.dataSource = createStore({
        loadUrl: `${url}/api/slims-report/comp-sales/comp-calculator`,
        onBeforeSend: (method, ajaxOptions) => {
          const token = this.getTokenSilently();
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          }
          ajaxOptions.data = {
            groupBy: this.currentGroupBy,
            timeRange: this.timeRange,
            metric: this.currentMetric,
            franchise: this.currentFranchiseGroup,
            fmm: this.currentFmm,
            fad: this.currentFad,
            clientId: clientId
          }
        }
      });
    },

    fadChanged(e)
    {
      this.currentFad = e.value;
      const url = this.getApiUrl();
      const clientId = this.getClientId();

      this.dataSource = createStore({
        loadUrl: `${url}/api/slims-report/comp-sales/comp-calculator`,
        onBeforeSend: (method, ajaxOptions) => {
          const token = this.getTokenSilently();
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          }
          ajaxOptions.data = {
            groupBy: this.currentGroupBy,
            timeRange: this.timeRange,
            metric: this.currentMetric,
            franchise: this.currentFranchiseGroup,
            fmm: this.currentFmm,
            fad: this.currentFad,
            clientId: clientId
          }
        }
      });
    },

    timeChanged(e) {

      this.timeRange = e.value
      const url = this.getApiUrl();
      const clientId = this.getClientId();

      this.dataSource = createStore({
        loadUrl: `${url}/api/slims-report/comp-sales/comp-calculator`,
        onBeforeSend: (method, ajaxOptions) => {
          const token = this.getTokenSilently();
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          }
          ajaxOptions.data = {
            groupBy: this.currentGroupBy,
            timeRange: this.timeRange,
            metric: this.currentMetric,
            franchise: this.currentFranchiseGroup,
            fmm: this.currentFmm,
            fad: this.currentFad,
            clientId: clientId
          }
        }
      });
    },


    onRowPrepared: function (e) {
      if (e.rowType === "data" && e.data.groupBy === 'Total') {
        e.rowElement.style.fontWeight = 'Bold';
      }
    },

    isTotalRow(data) {
      if (data.rowType === "data" && data.data.groupBy === 'Total') {
        return true;
      } else
        return false;


    },


    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
            location: 'before',
          }, {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              label: 'Group By',
              width: 170,
              placeHolder: "Select a group by",
              items: this.items,
              displayExpr: 'text',
              valueExpr: 'value',
              value: this.items[0].value,
              onValueChanged: this.groupChanged.bind(this)
            }
          },

          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 170,
              placeHolder: "Select a time range",
              items: this.timeItems,
              displayExpr: 'text',
              valueExpr: 'value',
              value: this.timeRange,
              onValueChanged: this.timeChanged.bind(this)
            }
          },

          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 170,
              placeHolder: "Select a Metric",
              items: this.metrics,
              displayExpr: 'text',
              valueExpr: 'value',
              value: this.metrics[0].value,
              onValueChanged: this.metricChanged.bind(this)
            }
          },

          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 170,
              placeHolder: "Select a Franchise Rollup",
              items: this.franchiseFilter,
              value: this.franchiseFilter[0].value,
              displayExpr: 'text',
              valueExpr: 'value',
              onValueChanged: this.franchiseChanged.bind(this)
            }
          },

          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 170,
              placeHolder: "Select a FMM Rollup",
              items: this.fmmFilter,
              value: this.fmmFilter[0].value,
              displayExpr: 'text',
              valueExpr: 'value',
              onValueChanged: this.fmmChanged.bind(this)
            }
          },

          {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
              width: 170,
              placeHolder: "Select a FAD Rollup",
              items: this.fadFilter,
              value: this.fadFilter[0].value,
              displayExpr: 'text',
              valueExpr: 'value',
              onValueChanged: this.fadChanged.bind(this)
            }
          },
      );
    },

  },

  mounted() {
    const url = this.getApiUrl();
    const clientId = this.getClientId();

    const token = this.getTokenSilently();
    axios.get(`${url}/api/slims-report/contribution-comp-filter`, {
      headers: {Authorization: `Bearer ${token}`},
      params: {
        type: 'Group',
        clientId: clientId
      }
    }).then(response => {
      for (let x = 0; x < response.data.length; x++) {
        this.franchiseFilter.push(response.data[x])
      }
      axios.get(`${url}/api/slims-report/contribution-comp-filter`, {
        headers: {Authorization: `Bearer ${token}`},
        params: {
          type: 'FMM',
          clientId: clientId
        }
      }).then(response => {
        for (let x = 0; x < response.data.length; x++) {
          this.fmmFilter.push(response.data[x])
        }
          axios.get(`${url}/api/slims-report/contribution-comp-filter`, {
            headers: {Authorization: `Bearer ${token}`},
            params: {
              type: 'FAD',
              clientId: clientId
            }
          }).then(response => {
            for (let x = 0; x < response.data.length; x++) {
              this.fadFilter.push(response.data[x])
            }
          });
      });
    });

    this.dataSource = createStore({
      loadUrl: `${url}/api/slims-report/comp-sales/comp-calculator`,
      onBeforeSend: (method, ajaxOptions) => {
        const token = this.getTokenSilently();
        ajaxOptions.headers = {
          Authorization: `Bearer ${token}`
        }
        ajaxOptions.data = {
          groupBy: "Channel",
          timeRange: this.timeRange,
          metric: "NetSales",
          franchise: "All",
          fmm: "All",
          fad: "All",
          clientId: clientId
        }
      }
    });
  }

}
</script>

<style scoped>
.top-metric {
  font-size: large;
}

.above-zero {
  background-color: rgba(63, 195, 128, 0.5);
}

.below-zero {
  background-color: rgba(255, 0, 47, 0.5);
}

.font-size {
  font-size: 1.1em;
}

.total-column {
  font-weight: bold;
}
</style>